export type TypeformCsatCampaign = {
  path: string;
  IdCampanha?: string | null;
};

export type TypeformCsatConfigurationResponse =
  | TypeformCsatCampaign[]
  | {
      Result?: TypeformCsatCampaign[];
      result?: TypeformCsatCampaign[];
    };

export interface ITypeformCsatGateway {
  obterConfiguracaoJson(): Promise<TypeformCsatCampaign[] | undefined>;
}

export const TypeformCsatGatewayDi = Symbol.for("TypeformCsatGatewayDi");
